import { useContext } from "react";
import { createContextProvider } from "../components/store-utils";
import { Account } from "../models/Account";
import { Tag } from "./tags-api";

export type TagState = {
    tags?:Record<string, Tag[]>
    editingTag?: Tag
    account?: Account
}

export type TagAction = {type: "setEditingTag", tag: Tag} | 
  {type: "setTags", tags:Record<string, Tag[]>} |
  {type: "setFranchiseTags", franchise: number,  tags:Tag[]} |
  {type: "setEditingAccount", account: Account}

function reducer(state: TagState, action: TagAction):TagState{
    switch(action.type){
        case "setEditingTag": return {...state, editingTag: action.tag}
        case "setTags": return {...state, tags: action.tags}
        case "setFranchiseTags": return {...state, tags: {...state.tags, [action.franchise]: action.tags}}
        case "setEditingAccount": return {...state, account: action.account}
        default: return state;
    }
}

export const [TagContext, TagStore] = createContextProvider(reducer, {})


export function useFranchiseTags(franchise:number){
    const {state} = useContext(TagContext);
    const a = state.tags[franchise];
    if(a)
        return a;
    return [];
}

export function useTagAccount(){
    const {state: {account}} = useContext(TagContext);
    return account;
}